import * as React from "react";
import { Rnd } from "react-rnd";
import RndClose from "../RndClose/RndClose";
import { Input } from "@mui/joy";
import { TextField } from "@mui/material";
import styled from "styled-components";
import { BiSave } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { setPlay } from "../../../../store/features/audioSlice";
import { RootState } from "../../../../store/store";
import { toast } from "react-toastify";
import { showPopupType } from "../../Sidebar";

export interface TimerProps {
  showTimerPopup: boolean;
  onShow: React.Dispatch<React.SetStateAction<showPopupType>>;
}

const Timer = React.memo(({ showTimerPopup, onShow }: TimerProps) => {
  const audioElm = document.querySelector<HTMLAudioElement>("#myAudio");
  const dispatch = useDispatch();
  const [hours, setHours] = React.useState<number>(0);
  const [minutes, setMinutes] = React.useState<number>(0);
  const [isActive, setIsActive] = React.useState<boolean>(false);
  const toggleTimer = () => {
    if (hours || minutes) {
      setIsActive(!isActive);
    } else {
      toast.warn("Please set a new time!", {
        autoClose: 1500,
        position: "top-center",
      });
      setIsActive(false);
    }
  };
  // console.log(hours, minutes, isActive);
  const resetTimer = () => {
    setIsActive(false);
    setHours(0);
    setMinutes(0);
  };
  React.useEffect(() => {
    let interval: any;
    if (isActive) {
      interval = setInterval(() => {
        if (hours === 0 && minutes === 0) {
          resetTimer();
          audioElm?.pause();
          dispatch(setPlay(false));
        } else {
          if (minutes === 0) {
            setHours((prevHours) => Math.max(0, prevHours - 1));
            setMinutes(59);
          } else {
            setMinutes((prevMinutes) => Math.max(0, prevMinutes - 1));
          }
        }
      }, 60000); //call after 60s
    } else {
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [isActive, minutes, hours]);
  return (
    <Rnd
      style={{
        zIndex: 350,
      }}
      enableResizing={false}
      dragHandleClassName="dragHandlePdf"
    >
      <StyledTimer
        style={{
          display: showTimerPopup ? "" : "none",
        }}
        className="absolute border border-bordermood flex flex-col    popup-timer top-0 -left-[350px] bg-timerBg px-3 rounded-lg"
      >
        <RndClose
          onClose={() =>
            onShow((prev) => {
              return {
                ...prev,
                showTimerPopup: !prev.showTimerPopup,
              };
            })
          }
        />
        <div className="w-80 has-scrollbar h-[230px]">
          <div className="text-white select-none text-center mb-3 uppercase font-medium text-lg">
            Countdown Audio Pause
          </div>
          <div className="p-3  justify-around rounded-md bg-bordermood flex items-center">
            <div className="timer-input w-[100px]">
              <TextField
                id="standard-basic"
                label="Hour"
                color="warning"
                variant="standard"
                type="number"
                value={hours.toString()}
                onChange={(e) =>
                  setHours(Math.max(0, parseInt(e.target.value)))
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className="timer-dot  text-3xl text-white">:</div>
            <div className="timer-input w-[100px]">
              <TextField
                type="number"
                id="standard-basic"
                label="Minute"
                variant="standard"
                color="warning"
                InputLabelProps={{
                  shrink: true,
                }}
                value={minutes.toString()}
                onChange={(e) =>
                  setMinutes(Math.max(0, parseInt(e.target.value)))
                }
              />
            </div>
          </div>
          <div className="flex mt-5 items-center gap-x-3 justify-center">
            <button
              onClick={toggleTimer}
              className="text-white shadow-md  hover:opacity-80 transition-all flex items-center gap-x-1  bg-saveBg text-sm font-normal uppercase px-3 py-2 w-[84px] rounded-md"
            >
              {isActive ? (
                <>
                  <i className="bi text-base bi-pause-fill"></i>
                  <span> Pause</span>
                </>
              ) : (
                <>
                  <i className="bi bi-play-fill"></i>
                  <span> Start</span>
                </>
              )}
            </button>
            <button
              onClick={resetTimer}
              className="text-white shadow-md  hover:opacity-80 transition-all flex items-center gap-x-1  bg-cancel text-sm font-normal uppercase px-3 py-2 rounded-md"
            >
              <i className="bi bi-trash3"></i>
              <span>Reset</span>
            </button>
          </div>
        </div>
      </StyledTimer>
    </Rnd>
  );
});

export default Timer;
const StyledTimer = styled.div`
  .css-xebkbb::before,
  .css-xlkdtz-MuiInputBase-root-MuiInput-root::before {
    border-bottom: 1px solid #fff !important;
  }
  .css-95a1d6,
  .css-1r74e2h-MuiFormLabel-root-MuiInputLabel-root {
    color: #ed6c02 !important;
  }
  .MuiInputBase-input,
  .css-18nu0jg-MuiFormLabel-root-MuiInputLabel-root {
    color: #fff !important;
  }
  .css-1x51dt5-MuiInputBase-input-MuiInput-input {
    color: #fff !important;
  }
  .css-xebkbb:hover:not(.Mui-disabled, .Mui-error)::before {
    border-bottom: 2px solid #fff !important;
  }
  .MuiInputLabel-root {
    color: #ed6c02 !important;
  }
  /* Ẩn nút tăng/giảm trên input type number */
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }
`;
